var map = {
	"./APPR.svg": "eea1",
	"./CAN.svg": "4f62",
	"./CLOSED.svg": "9703",
	"./COMP.svg": "0082",
	"./DISPTCHD.svg": "5371",
	"./FLDCOMP.svg": "8f49",
	"./INPRG.svg": "a4dd",
	"./PENDING.svg": "dccd",
	"./WAPPR.svg": "8007"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "495f";